import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Shared BikesDrop Firebase project (pharmaghana-913f6), same project used by
// the bikesdrop, bikesdrop-business and bikesdrop-console apps. apiKey,
// authDomain, projectId and storageBucket are identical across every
// registered web app in this project (Firebase web API keys are not secret).
// appId/measurementId identify this landing page as its own registered app.
const firebaseConfig = {
  apiKey: 'AIzaSyBAKUu3s8futA7iHmtZIHKcwnPoBsWCq-I',
  authDomain: 'pharmaghana-913f6.firebaseapp.com',
  projectId: 'pharmaghana-913f6',
  storageBucket: 'pharmaghana-913f6.firebasestorage.app',
  messagingSenderId: '216201895260',
  appId: '1:216201895260:web:73b95aab9fd6d05c8e7599',
  measurementId: 'G-5RNPM6NQDW',
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// measurementId has sat unused since this was first configured, no
// analytics data has ever actually been collected. isSupported() guards
// against environments Firebase Analytics can't run in at all (SSR/build
// time, a headless prerender crawl, browsers blocking the storage APIs it
// needs), resolving analytics to null there instead of throwing.
export const analyticsPromise = isSupported().then((supported) => (supported ? getAnalytics(app) : null));
